<script setup lang="ts">
    import {ContactUsRoute} from "@/domains/-contact-us/view";

    //import Person from "@/resources/person/Person.js";
    import { odsNavigation, odsNavigationItem } from "omind-design-system/components/odsNavigation"
    //import SESSION from "@/resources/session/session.js";
    import { loadLocales } from "@/i18n";
    import { LOCALE_CATEGORIES } from "@/assets/locales/categories.ts";
    import {useSessionStore} from "@/domains/-session/stores/useSessionStore"
import { getAdminListRouteLocation } from "@/domains/-admin/-list/routes";
import { usePermissionManager } from "@/domains/-permissions/stores/usePermissionManager";

    loadLocales(LOCALE_CATEGORIES.NAVIGATION)

    const SESSION = useSessionStore()
    const me = SESSION.me
    const permissions = usePermissionManager()

    
</script>

<template>
    <odsNavigation>
        <odsNavigationItem
            v-if="permissions.canI('create_staff')"
            :icon="'instant_mix'"
            :label="$t('navigation.admin')"
            :to="{name: 'admin_list'}"
        />
        <odsNavigationItem
            :icon="'alternate_email'"
            :label="$t('navigation.contact_us')"
            :to="{name: 'contact'}"
        />
        <odsNavigationItem
            :label="$t('navigation.account')"
            :to="{name: 'account'}"
        >
          <template v-slot:icon>
            <span class="avatar">{{ me?.initials }}</span>
          </template>
        </odsNavigationItem>
        <!-- <odsNavigationItem
            :icon="'chat_bubble'"
            :label="$t('navigation.contact')"
            :to="{name: 'contact'}"
        /> -->
    </odsNavigation>
</template>

<style lang="scss">
    .avatar{
        text-transform: uppercase;
    }
</style>